import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import NavMenu from './NavMenu';
import { getConfig } from '../../routing';
import cyberFoxLogo from '../../images/brand/cyberfox-logo-black.svg';

const drawerWidth = 240;

const styles = theme => ({
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    drawerPaper: {
        position: 'fixed',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: 0,
    },
    h5: {
        marginBottom: theme.spacing(2),
    },
    leftSidebarlogo: {
        height: '52px',
    },
    toolbarLogoText: {
        fontWeight: 500,
        marginLeft: '8px',
    },
});

const ToolbarLogo = ({ classes }) => (
    <div className={classes.toolbarIcon}>
        <img
            src={cyberFoxLogo}
            className={classes.leftSidebarlogo}
            alt="CyberFOX Password Manager"
        />
        <Typography
            className={classes.toolbarLogoText}
            component="h3"
            color="textSecondary"
        >
            Partner Portal
        </Typography>
    </div>
);

class Nav extends React.PureComponent {
    state = {
        menu: {},
        config: getConfig(),
    };

    handleUpdateMenu = (menu, config) => {
        this.setState({ menu, config });
    };

    render() {
        const { classes } = this.props;
        const { menu, config } = this.state;
        return (
            <nav>
                <Hidden smUp>
                    <Drawer
                        variant="temporary"
                        classes={{
                            paper: classNames(
                                classes.drawerPaper,
                                !this.props.mobileOpen &&
                                    classes.drawerPaperClose
                            ),
                        }}
                        open={this.props.mobileOpen}
                        onClose={this.props.handleDrawerOpen}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        <ToolbarLogo classes={classes} />
                        <Divider />
                        <NavMenu
                            drawerOpened={this.props.open}
                            onAccountMenuClick={this.props.handleActionMenuOpen}
                            menu={menu}
                            onUpdateMenu={this.handleUpdateMenu}
                            config={config}
                        />
                    </Drawer>
                </Hidden>
                <Hidden xsDown>
                    <Drawer
                        variant="permanent"
                        classes={{
                            paper: classNames(
                                classes.drawerPaper,
                                !this.props.open && classes.drawerPaperClose
                            ),
                        }}
                        open={this.props.open}
                    >
                        <ToolbarLogo classes={classes} />
                        <Divider />
                        <NavMenu
                            drawerOpened={this.props.open}
                            onAccountMenuClick={this.props.handleActionMenuOpen}
                            menu={menu}
                            onUpdateMenu={this.handleUpdateMenu}
                            config={config}
                        />
                    </Drawer>
                </Hidden>
            </nav>
        );
    }
}

export default withStyles(styles)(Nav);
